import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonPointAction} from "../../../../componentsTopsa/buttons/TopButtons";
import {Link} from "react-router-dom";
import {ButtonToolbar, Form, FormControl} from "react-bootstrap";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertSukces} from "../../../../componentsTopsa/alerty/TopAlerts";
import WyslijMailDoKlientaPopup from "../../../komunikaty/powiadomienia/external_component/WyslijMailDoKlientaPopup";

export default class EBOKWiadomosciTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyEdycjaTematu: false,
            nowyTytul: null,
            nowyTytulDodatek: '',
            pokazPopupWyslijEmail: false,
            adresatEmail: ""
        };
        this.renderButtons = this.renderButtons.bind(this)
        this.renderTemat = this.renderTemat.bind(this)
        this.pogrubJesliNieWyswietlono = this.pogrubJesliNieWyswietlono.bind(this)
    }

    renderButtons(cell, row) {
        return <Link to={'/zarzadzanie-klientami/ebok/zgloszenie/' + cell} target={'_blank'}><TopButtonPointAction
            onClick={() => {
            }} buttonIcon={'fa fa-external-link'} titleContent={'Zobacz wątek'}/></Link>
    }

    renderTemat(cell, row) {
        if (this.state.czyEdycjaTematu === row.idZgl) {
            return <div>
                <div style={{display: "inline-block", width: "270px", fontSize: "12px"}}>

                    <TopSelect onChange={(e) => this.setState({nowyTytul: e})} value={this.state.nowyTytul} options={
                        [
                            {value: 'FAKTURY_CENY', label: 'Faktury / ceny'},
                            {value: 'INFORMACJE', label: 'Informacje'},
                            {value: 'ZWROT_BILETU', label: 'Zwrot biletu'},
                            {value: 'INNE', label: 'Inne'}
                        ]
                    }/>
                </div>
                {
                    (this.state.nowyTytul) ?
                        (this.state.nowyTytul.value === "Zwrot biletu" || this.state.nowyTytul.value === "INNE") ?
                            <div style={{display: "inline-block", width: "270px", fontSize: "12px"}}>
                                <FormControl onChange={(e) => this.setState({nowyTytulDodatek: e.target.value})}
                                             placeholder={(this.state.nowyTytul.value === "ZWROT_BILETU") ? "Nr biletu" : ""}/>
                            </div>
                            :
                            ""
                        :
                        ""
                }

                <TopButtonPointAction onClick={() => this.setState({czyEdycjaTematu: false, nowyTytul: null, nowyTytulDodatek: ''})}
                                      buttonIcon={"fa fa-times"}
                                      buttonColor={"default"}/>
                <TopButtonPointAction onClick={() => this.onZapiszNowyTemat(row.idZgl)} buttonIcon={"fa fa-save"} buttonColor={"primary"}/>
            </div>
        }
        else {
            return <div>
                <Link to={'/zarzadzanie-klientami/ebok/zgloszenie/' + row.idZgl} target={'_blank'}
                      style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>{cell} </Link>
                <i style={{
                    display: "inline-block",
                    width: "30px",
                    cursor: "pointer",
                    color: "grey",
                    textAlign: "center"
                }} className={"fa fa-pencil"} title={"Edytuj temat wiadomości"}
                   onClick={() => this.setState({czyEdycjaTematu: row.idZgl, nowyTytul: null})}></i>

            </div>
        }

    }

    renderKlient(cell, row) {
        if (Boolean(row.idKl))
            if (row.idKl === 1) {
                return <span style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}
                             title={'Klient anonimowy - nie posiada konta'}>{cell}</span>
            } else
                return (<span>
                <i className={'fa fa-user-circle-o'} title={'Klient posiada konto'} style={{marginRight: '5px'}}></i>
                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}
                      style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>{cell}</Link>
            </span>)
    }

    renderCzyOdpowiedziano(cell, row) {
        if (Boolean(cell)) return <i className={'fa fa-check'} style={{color: 'forestgreen'}}
                                     title={'Odpowiedziano'}></i>
        else return <i className={'fa fa-times'} style={{color: 'firebrick'}} title={'Nie odpowiedziano'}></i>
    }

    renderStatus(cell, row) {
        if (cell === 0) {
            return <i className={'fa fa-comments'} style={{color: 'forestgreen'}} title={'Wątek otwarty'}></i>
        } else if (cell === 1) {
            return <i className={'fa fa-ban'} style={{color: '#676767'}} title={'Wątek zakończony'}></i>
        } else if (cell === 2) {
            return <i className={'fa fa-gear'} style={{color: 'dodgerblue'}} title={'W realizacji'}></i>
        }
    }

    pogrubJesliNieWyswietlono(cell, row,czyEmail=false) {
        if (Boolean(cell))
            return <span style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>
                {
                    czyEmail?
                        <span
                            style={{display: 'inline-block', color: "dodgerblue", textDecoration: "underline", cursor:"pointer"}}
                            onClick={() => this.setState({
                                pokazPopupWyslijEmail: true, adresatEmail: row.emailKl
                            })}>
                            {cell}
                        </span>
                        :
                        cell
                }
                </span>
    }

    formatDataIGodzina(cell, row) {
        if (Boolean(cell)) {
            return <span
                style={(row.czyOdpKl && !row.czyOdpBok) ? {
                    fontWeight: 'bold',
                    fontSize: "12px"
                } : {fontSize: "12px"}}>{cell.substr(0, 16).replace('T', ' ')}</span>
        }
    }

    formatDataKursu(cell, row) {
        if (Boolean(cell)) {
            return <div>
                <div
                    style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>
                    {cell.substr(0, 16).replace('T', ' ')}
                </div>
                <div style={{fontSize: "10px"}}>
                    {
                        (cell.substr(0, 10) >= new Date().toJSON().substr(0, 10)) ?
                            <TopAlertOstrzezenie text={"Kurs jeszcze się nie odbył"} inline={true}/>
                            :
                            <TopAlertSukces text={"Kurs odbył się"} inline={true}/>

                    }
                </div>
            </div>
        }
    }

    formatDaty(cell, row) {
        if (Boolean(row.nrBil)) {
            return <div style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>
                {
                    Boolean(row.dataWpisu) ?
                        <div><label>Zgloszono:</label> <span>{row.dataWpisu.substr(0, 16).replace('T', ' ')}</span></div>
                        : ""
                }
                {
                    (Boolean(row.dataZmiany) && (row.dataWpisu !== row.dataZmiany)) ?
                        <div><label>Zmieniono:</label> <span>{row.dataZmiany.substr(0, 16).replace('T', ' ')}</span></div>
                        : ""
                }
                {
                    Boolean(row.dataKuTs) ?
                        <div><label>Data kursu:</label> <span>{row.dataKuTs.substr(0, 16).replace('T', ' ') + " "}
                            {/*{
                                (row.dataKuTs.substr(0, 10) >= new Date().toJSON().substr(0, 10)) ?
                                    <i className={"fa fa-times-circle"} style={{color: "darkorange"}} title={"Kurs jeszcze się nie odbył"}></i>
                                    :
                                    <i className={"fa fa-check-circle"} style={{color: "forestgreen"}} title={"Kurs już się odbył"}></i>

                            }*/}
                        </span></div>
                        : ""
                }

            </div>
        } else {
            return <div style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "12px"} : {fontSize: "12px"}}>
                {
                    Boolean(row.dataWpisu) ?
                        <div><label>Zgloszono:</label> <span>{row.dataWpisu.substr(0, 16).replace('T', ' ')}</span></div>
                        : ""
                }
                {
                    (Boolean(row.dataZmiany) && (row.dataWpisu !== row.dataZmiany)) ?
                        <div><label>Zmieniono:</label> <span>{row.dataZmiany.substr(0, 16).replace('T', ' ')}</span></div>
                        : ""
                }
            </div>
        }
    }

    formatCzyZwrocic(cell, row) {
        if (row.temat.indexOf('Zwrot biletu') > -1) {
            return <div>
                <div
                    style={(row.czyOdpKl && !row.czyOdpBok) ? {fontWeight: 'bold', fontSize: "10px"} : {fontSize: "10px"}}>
                    <div title={"Czy minął dzień roboczy od odbycia się kursu?"}><label>Czy minął dzień?</label> <span>{(row.czyMinalDzien) ?
                        <i className={"fa fa-check"} style={{color: "forestgreen"}}></i> :
                        <i className={"fa fa-times"} style={{color: "darkorange"}}></i>}</span></div>
                    <div title={"Czy bilet został zgłoszony najpóźniej 30min przed kursem?"}><label>Czy zgłoszony o czasie?</label> <span>{(row.czyZgloszonyOCzasie) ?
                        <i className={"fa fa-check"} style={{color: "forestgreen"}}></i> :
                        <i className={"fa fa-times"} style={{color: "darkorange"}}></i>}</span></div>
                    <div title={"Czy bilet można zwrócić (czy spełniono powyższe warunki)?"} style={{fontSize:"12px"}}><label>Czy mozna zwrócić?</label> <span>{(row.czyMoznaZwrocic) ?
                        <i className={"fa fa-check"} style={{color: "forestgreen"}}></i> :
                        <i className={"fa fa-times"} style={{color: "darkorange"}}></i>}</span></div>
                </div>
            </div>
        }
    }

    onZapiszNowyTemat(idZgl) {

        if (Boolean(this.state.nowyTytul)) {

            let newtemat = this.state.nowyTytul.label

            if ((this.state.nowyTytul.value === "ZWROT_BILETU" || this.state.nowyTytul.value === "INNE")) {
                if (this.state.nowyTytulDodatek.length > 0) {
                    newtemat = newtemat + " " + this.state.nowyTytulDodatek
                }
            }


            this.setState({czyEdycjaTematu: false})

            this.props.handleChangeTemat(idZgl, newtemat)

        } else {
            alert("Nie wybrano tematu")
        }
    }

    render() {

        const options = {
            sizePerPageList: [10, 15, 30, 50, 100, 200],
            noDataText: 'Brak pasujących rekordów',
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };

        return (
            <div>
                <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                    Ilość wszystkich zgłoszeń: {Boolean(this.props.pageable.totalElements) ? this.props.pageable.totalElements : 0}
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                    remote={true}
                                    hover
                    >
                        <TableHeaderColumn dataField='idZgl' isKey hidden={false} thStyle={tabgrid.tg1}
                                           tdStyle={tabgrid.tg1}
                                           dataFormat={this.pogrubJesliNieWyswietlono}
                        >ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWpisu'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           dataFormat={this.formatDaty}
                        >Ramy czasowe</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyMoznaZwrocic'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.formatCzyZwrocic}
                                           hidden={this.props.wybranyTemat !== "ZWROT_BILETU"}
                        >Możliwość zwrotu</TableHeaderColumn>
                        <TableHeaderColumn dataField='klient'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.renderKlient}
                        >Zgłaszający</TableHeaderColumn>
                        <TableHeaderColumn dataField='emailKl'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           dataFormat={(cell,row)=>this.pogrubJesliNieWyswietlono(cell,row,true)}
                        >Email zgłaszającego</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrBil'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.pogrubJesliNieWyswietlono}
                        >Nr Biletu</TableHeaderColumn>
                        <TableHeaderColumn dataField='temat'
                                           thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                           dataFormat={this.renderTemat}
                        >Temat</TableHeaderColumn>
                        <TableHeaderColumn dataField='status'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.renderStatus}
                        >Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='idZgl'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.renderButtons}
                        >Zobacz</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {
                    (this.state.pokazPopupWyslijEmail) ?
                        <WyslijMailDoKlientaPopup adresat={this.state.adresatEmail}
                                                  onClickZamknij={() => this.setState({pokazPopupWyslijEmail: false, adresatEmail: ""})}/>
                        : ""
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/components/EBOKWiadomosciTable.js